const config = {
  authBaseUrl: process.env.REACT_APP_URL,
  environment: process.env.REACT_APP_PROJECT_ENV,
  referralBaseUrl: process.env.REACT_APP_REFERRAL_BASE_URL,
  analyticsClientId: process.env.REACT_APP_LIGHTSKI_CLIENT_ID,
  analyticsEmbedId: process.env.REACT_APP_LIGHTSKI_EMBED_ID,
  mixpanelProjectToken: process.env.REACT_APP_MIXPANEL_PROJECT_TOKEN,
};

export default config;
